export default __webpack_public_path__ + "static/material-icons-regular-513028f86001882d268787802c1a3576.ttf";